var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'has-search': _vm.hasSearch },attrs:{"id":"page"}},[_c('headBar',{attrs:{"hasSearch":_vm.hasSearch}}),_c('router-view',{key:_vm.$route.fullPath}),_c('navBars')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }